<template>
  <div>
    <a-row class="iotplt-card-box">
      <a-col>
        <a-form
          class="iotplt-compact-form"
          :form="form"
          label-align="left"
          :label-col="{ span: 2 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-form-item
            label="产品型号"
          >
            <a-spin :spinning="loadingProducts">
              <a-radio-group
                button-style="solid"
                @change="handleProductChange"
                v-decorator="['base_cpe_product_id', {
                  rules: [{ required: true, message: '请选择产品型号' }]
                }]"
              >
                <a-radio-button
                  class="card-select-box card-product-box"
                  v-for="product in productOptions"
                  :key="product.id"
                  :value="product.id"
                >
                  {{ formatProductLabel(product) }}
                </a-radio-button>
              </a-radio-group>
              <a-empty
                v-if="!loadingProducts && productOptions.length === 0"
                description="暂无上架CPE产品"
                :image="simpleImage"
              />
            </a-spin>
          </a-form-item>

          <a-descriptions
            :column="1"
            class="iotplt-descriptions iotplt-descriptions-max-6"
          >
            <a-descriptions-item label="库存量">
              <a-spin :spinning="loadingInventory" size="small">
                <span v-if="selectedCpeModelId">{{ inventoryCountDisplay }}</span>
                <span v-else class="placeholder-text">-</span>
              </a-spin>
            </a-descriptions-item>
          </a-descriptions>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import { findBaseCpeProducts } from '@/api/base_cpe_product'
import { findCpeInventoryStatistics } from '@/api/cpe_inventory'

export default {
  name: 'SalesInventoryCheckCpes',
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sales_inventory_check_cpes' }),
      productOptions: [],
      selectedCpeModelId: undefined,
      inventoryCount: null,
      loadingProducts: false,
      loadingInventory: false
    }
  },
  computed: {
    inventoryCountDisplay() {
      if (this.inventoryCount === null || this.inventoryCount === undefined) {
        return '-'
      }
      return this.inventoryCount
    }
  },
  created() {
    this.fetchProductOptions()
  },
  methods: {
    formatProductLabel(product) {
      const displayModel = product.display_model || product.cpe_model_name || ''
      const commModeName = product.comm_mode_name || ''
      if (displayModel && commModeName) {
        return `${displayModel} / ${commModeName}`
      }
      return displayModel || commModeName || '-'
    },

    fetchProductOptions() {
      this.loadingProducts = true
      findBaseCpeProducts({
        effective: '1',
        page: 1,
        per_page: 500
      }).then((res) => {
        if (res.code === 0) {
          this.productOptions = res.data || []
        }
        this.loadingProducts = false
      }).catch(() => {
        this.loadingProducts = false
      })
    },

    fetchInventory(cpeModelId) {
      this.inventoryCount = null
      if (!cpeModelId) {
        return
      }
      this.loadingInventory = true
      findCpeInventoryStatistics({
        cpe_model_id: cpeModelId,
        page: 1,
        per_page: 1
      }).then((res) => {
        if (res.code === 0) {
          const row = (res.data || [])[0]
          this.inventoryCount = row ? row.inventory_count : 0
        }
        this.loadingInventory = false
      }).catch(() => {
        this.loadingInventory = false
      })
    },

    handleProductChange(e) {
      const productId = e.target.value
      const product = this.productOptions.find((item) => item.id === productId)
      this.selectedCpeModelId = product ? product.cpe_model_id : undefined
      this.fetchInventory(this.selectedCpeModelId)
    }
  }
}
</script>

<style lang="less" scoped>
.card-select-box {
  margin: 0 10px 5px 0;
  border-radius: 0 !important;
  border: 1px solid #d9d9d9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.card-product-box {
    min-width: 140px;
    max-width: 320px;
  }
}

.placeholder-text {
  color: rgba(0, 0, 0, 0.45);
}
</style>
